export default "__VITE_ASSET__0603329e__"